import { Country } from '~/services/api/enums';

const countryOptions = [
  {
    value: Country.UnitedStates,
    label: 'USA',
  },
];

export default countryOptions;
